import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import RelocationCargoItemByQrButton from './RelocationCargoItemByQrButton';
import ManualRelocationCargoItemButton from './manual-relocation-cargo-item/ManualRelocationCargoItemButton';

const RelocationCargoItemToolbar = ({
  disabled,
  locationId,
  location,
  onHandleClear,
}) => (
  <ButtonToolbar className="pull-right">
    <div>
      <RelocationCargoItemByQrButton
        disabled={disabled}
        locationId={locationId}
        location={location}
        onHandleClear={onHandleClear}
      />{' '}
      <ManualRelocationCargoItemButton
        location={location}
        onHandleClear={onHandleClear}
      />
    </div>
  </ButtonToolbar>
);

RelocationCargoItemToolbar.propTypes = {
  disabled: PropTypes.bool,
  locationId: PropTypes.number,
  location: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }).isRequired,
  onHandleClear: PropTypes.func.isRequired,
};

RelocationCargoItemToolbar.defaultProps = {
  disabled: false,
  locationId: 0,
};

const mapStateToProps = ({ CargoUnit }) => ({
  loadingItemToItinerary: !CargoUnit.ItemToItinerary.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

export default connect(mapStateToProps, null)(RelocationCargoItemToolbar);
